import { pyAPI } from 'constants/api';
import fetchApi from 'services/fetch';
import { accentReplace } from 'utils/textFormatter';

const initialState = {
  coverage: {},
  // selectedLocation: { lat: -23.442503, lng: -58.443832 },
  selectedLocation: { lat: null, lng: null },
  selectedCoverage: null,
  installationType: null,
  selectedBuilding: null,
};

export const location = {
  state: { ...initialState },
  reducers: {
    updateCoverage(state, payload) {
      return {
        ...state,
        coverage: payload?.coverage,
        selectedCoverage: payload?.selected,
      };
    },
    import(state, payload) {
      return { ...state, ...payload };
    },
    updateInitialCoverage(state, payload) {
      return { ...state, initialCoverage: payload?.data };
    },
    updateLocation(state, payload) {
      return { ...state, selectedLocation: payload };
    },
    updateInstallationType(state, payload) {
      return { ...state, installationType: payload };
    },
    updateSelectedBuilding(state, payload) {
      return { ...state, selectedBuilding: payload };
    },
    clearCoverage() {
      return { ...initialState };
    },
  },

  effects: (dispatch) => {
    return {
      async checkCoverage({ latitude, longitude }) {
        dispatch.apiStatus.setProcessing(true);
        this.updateCoverage({ coverage: {}, selected: {} });
        dispatch.activation.updateCoverageLocation({ lat: null, lng: null });
        dispatch.activation.updateClientInformation({
          ...{
            street: null,
            city: {},
            numberFrom: '',
            toNumber: '',
            streetNumber: '',
            selectedButtonText: '',
            state: {},
            department: '',
            obj: {},
          },
        });
        return fetchApi({
          method: 'GET',
          url: pyAPI.checkCoverage,
          params: { latitude, longitude },
        })
          .then(async (response) => {
            let data = getAddreesData(response?.data?.coverage);
            console.log('checkCoverage', { data });
            if (!data?.city?.id) {
              const res = await this.reverseGeocode(`${longitude},${latitude}`);
              if (res.success) {
                const resp = await this.getGeoData({
                  technology: data?.selectedButtonText?.toUpperCase(),
                  cityName: accentReplace(
                    res?.response?.features?.find((x) => x.type === 'Feature' && x.place_type?.[0] === 'place')?.text ||
                    ''
                  ),
                });
                data = {
                  ...data,
                  city: { ...(resp?.response?.locations?.cities?.[0] || {}) },
                };
              }
            }
            this.updateCoverage({
              coverage: response?.data?.coverage,
              selected: data,
            });
            console.log('dispatch checkCoverage fetchapi success updateInitialCoverage', { data });

            this.updateInitialCoverage({ data });
            console.log('dispatch checkCoverage fetchapi success state after');
            console.log('dispatch checkCoverage fetchapi success dispatch.state after', dispatch.location.state);
            dispatch.activation.updateClientInformation({ ...data });
            dispatch.activation.updateCoverageLocation({ lat: latitude, lng: longitude });

            dispatch.apiStatus.setRequestFailed({
              message: `<span>¡La <b>tecnología ${data?.obj?.technology?.toUpperCase()}</b> de Tigo Hogar se encuentra disponible aquí!</span>`,
              has: true,
              errorCode: 200,
            });
            return Promise.resolve({ success: true });
          })
          .catch((err) => {
            dispatch.apiStatus.setProcessing(false);
            if (err.errorCode === 404) {
              this.updateCoverage({
                coverage: [],
                selected: {
                  selectedButtonText: 'dth_siebel',
                  obj: { technology: 'dth_siebel' },
                },
              });
              dispatch.activation.updateClientInformation({
                selectedButtonText: 'dth_siebel',
                obj: { technology: 'dth_siebel' },
              });
              dispatch.activation.updateCoverageLocation({ lat: latitude, lng: longitude });
              return Promise.resolve({ success: true });
            } else {
              dispatch.apiStatus.setRequestFailed({
                ...err,
                message:
                  'Tigo Hogar no esta disponible aqui. Verifica que el pin este ubicado correctamente en el mapa o escribe nueva nuevamente tu dirección.',
              });
            }
          });
      },

      async getAddress({ search }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.searchAddrees,
          data: {
            output: 'json',
            input: search,
            // types: 'geocode',
            components: 'country:py',
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({
              success: true,
              response: response?.data?.predictions,
            });
          })
          .catch((err) => {
            console.error('getAddress error', err);
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },

      async findAddress({ search }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.findAddressCordinates,
          data: {
            output: 'json',
            place_id: search,
            fields: 'geometry',
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({
              success: true,
              response: response?.data?.result?.geometry?.location || {},
            });
          })
          .catch((err) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },

      async reverseGeocode(latLng) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'POST',
          url: pyAPI.reverseGeocode,
          data: {
            endpoint: 'mapbox.places',
            coordinates: latLng,
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((err) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },

      async getGeoData({ technology, cityName }) {
        dispatch.apiStatus.setProcessing(true);
        return fetchApi({
          method: 'GET',
          url: pyAPI.getGeographicLocation,
          params: {
            'location.technology': technology,
            'location.city': cityName,
          },
        })
          .then((response) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: true, response: response?.data });
          })
          .catch((err) => {
            dispatch.apiStatus.setProcessing(false);
            return Promise.resolve({ success: false });
          });
      },
    };
  },
};

const getAddreesData = (list = []) => {
  const hfc = list?.find((x) => x.technology?.toLowerCase() === 'hfc');
  const hfcSiebel = list?.find((x) => x.technology?.toLowerCase() === 'hfc_siebel');
  const fibra = list?.find((x) => x.technology?.toLowerCase() === 'fibra');
  const obj = list?.find((x) => x.technology?.toLowerCase() === 'ftth') || fibra || hfcSiebel || hfc || list?.[0] || {};

  if (obj.technology?.toLowerCase() === 'ftth' || obj.technology?.toLowerCase() === 'hfc_siebel') {
    obj.next = getFormattedData(hfc || fibra || list?.find((x) => x.technology?.toLowerCase() === 'dth') || {});
  }
  return getFormattedData(obj);
};

const getFormattedData = (obj) => {
  if (obj?.city) {
    return {
      city: { id: obj.cityID, city: obj.city, state: obj.state },
      state: obj.state ? { id: obj.stateID, state: obj.state } : undefined,
      numberFrom: obj.fromNumber,
      toNumber: obj.toNumber,
      street: ['dth', 'ftth', 'hfc_siebel', 'dth_siebel'].includes(obj.technology?.toLowerCase())
        ? obj.street
        : {
          addressName: obj.street,
          id: obj.streetID,
          numberFrom: obj.fromNumber,
          numberTo: obj.toNumber,
        },
      selectedButtonText: obj.technology?.toLowerCase() === 'fibra' ? 'hfc' : obj.technology?.toLowerCase(),
      streetNumber: obj.nearNumber,
      department:
        obj.technology?.toLowerCase() === 'ftth' || obj.technology?.toLowerCase() === 'hfc_siebel' ? obj.state : '',
      obj: {
        ...obj,
      },
    };
  }

  if (obj?.technology?.toLowerCase() === 'dth' && (!obj?.city || !obj?.cityID || !obj?.state || !obj?.stateID)) {
    return {
      selectedButtonText: 'dth_siebel',
      obj: {
        ...obj,
        technology: 'dth_siebel',
      },
    };
  }

  return {
    selectedButtonText: obj?.technology ? obj?.technology : 'dth',
    obj: obj,
  };
};
